import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from './constants';
import { createErrorFromAxiosMultipleErrors } from './utilities';

const DISCOUNT_RULE_URL = `${BUSINESS_ADMIN_HOST}/v1/discount-rules`;

export function getDiscountRulesApi() {
  return axios.get(`${DISCOUNT_RULE_URL}?visible=true`);
}

export function createDiscountRuleApi(ruleData) {
  return axios.post(DISCOUNT_RULE_URL, ruleData);
}

export function updateDiscountRuleApi(ruleData) {
  return axios.put(`${DISCOUNT_RULE_URL}/${ruleData.id}`, ruleData);
}

export function deleteDiscountRuleApi(ruleId) {
  return axios.delete(`${DISCOUNT_RULE_URL}/${ruleId}`);
}

export async function getDiscountRuleLogs(page, size) {
  try {
    return await axios.get(
      `${BUSINESS_ADMIN_HOST}/v1/logs?group=discount_rules`,
      {
        params: { page, size },
      }
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
